module.exports = __webpack_public_path__ + "img/osint-logo1.4a37785d.png";